import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import { Participant } from "./Participant/Participant.component";

import "./Participants.css";

const Participants = (props) => {
  const [hasPinned, setHasPinned] = useState({ index: 0, hasPinned: false  })

  const videoRef = useRef(null);
  let participantKey = Object.keys(props.participants);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = props.stream;
      videoRef.current.muted = true;
    }
  }, [props.currentUser, props.stream]);

  const currentUser = props.currentUser
    ? Object.values(props.currentUser)
    [0]
    : null;

  const loopParticipants = (element, index) => {
    const currentParticipant = props.participants[element];
    const isCurrentUser = currentParticipant.currentUser;
    
    if (isCurrentUser) return null;
    
    const pc = currentParticipant.peerConnection;
    const remoteStream = new MediaStream();
    
    let curentIndex = index;
    
    if (pc) {
      pc.ontrack = (event) => {
        event.streams[0].getTracks().forEach((track) => {
          remoteStream.addTrack(track);
        });
        const videElement = document.getElementById(
          `participantVideo${curentIndex}`
        );
        if (videElement) videElement.srcObject = remoteStream;
      };
    }

    const participantProps = {
      onPin: (value, element) => {
        setHasPinned(value)
      },
      element,
      key: curentIndex,
      currentParticipant: currentParticipant,
      curentIndex: curentIndex,
      hideVideo: false,
      showAvatar: !currentParticipant.video && !currentParticipant.screen && currentParticipant.name
    }

    const wrapperProps = {
      style: hasPinned.hasPinned ? (hasPinned.index !== index ? { display: 'none' } : { width: '100%', height: '100%' }) : undefined,
      id: index % 2 === 0 ? 'down' : 'up'
    }
  
    return (
      <div {...wrapperProps} key={`other-participants ${index}`} >
        <Participant {...participantProps} />
      </div>
    )
  }

  const participants = participantKey.map(loopParticipants);

  const currentUserProps = {
    onPin: ({ index, hasPinned }) => {
      setHasPinned({ index: hasPinned ? index : 0, hasPinned })
    },
    showParticipants: props.showParticipants,
    currentParticipant: currentUser,
    curentIndex: participantKey.length,
    videoRef: videoRef,
    showAvatar: currentUser && !currentUser.video && !currentUser.screen,
    currentUser: true,
    hasPinned: hasPinned.hasPinned,
    pinnedIndex: hasPinned.index
  }

  const wrapperCurrentuser = {
    width: '100%',
    height: '30%'
  }

  return (
    <div className='participants' style={!hasPinned.hasPinned ? { flexDirection:  'column' } : { flexDirection: 'row', justifyContent: 'space-between' }}>
      {participants}

      <div style={wrapperCurrentuser}>
        <Participant {...currentUserProps} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    participants: state.participants,
    currentUser: state.currentUser,
    stream: state.mainStream,
  };
};

export default connect(mapStateToProps)(Participants);

